export const getSectionHasSaved = (formValues, pageIndex) => {
  const savedSections = formValues?.savedSections || formValues?._savedSections

  switch (pageIndex) {
    case 0:
      return savedSections?.includes('BUSINESS_INFO')
    case 1:
      return savedSections?.includes('FINANCE_INFO')
    case 2:
      return savedSections?.includes('AUTH_SIGNER')
    case 3:
      return savedSections?.includes('COMPANY_OWNERS')
  }
}
